/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsnav2Inputs */

const en_aicostsnav2 = /** @type {(inputs: Aicostsnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI costs`)
};

const de_aicostsnav2 = /** @type {(inputs: Aicostsnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Kosten`)
};

/**
* | output |
* | --- |
* | "AI costs" |
*
* @param {Aicostsnav2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsnav2 = /** @type {((inputs?: Aicostsnav2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsnav2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsnav2(inputs)
	return de_aicostsnav2(inputs)
});
export { aicostsnav2 as "aiCostsNav" }